import * as React from 'react';
import styles from './style.css';


interface IBubbleContainer {
    title: string;
    children: any;
    containerStyle?: any;
    innerStyle?: any;
    theme?: string
}

// `theme` is still passed by older callers and ignored: colors come from the
// app theme tokens.
export default function BubbleContainer({title, children, containerStyle, innerStyle}: IBubbleContainer) {
    return (
        <div className={styles.container} style={containerStyle || {}}>
            <div className={styles.title}>
                {title}
            </div>
            <div className={styles.inner} style={innerStyle || {}}>
                {children}
            </div>
        </div>
    );
}
